import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const CheckCircle: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M22 11.08V12a10 10 0 1 1-5.93-9.14' }],
    ['path', { d: 'm9 11 3 3L22 4' }],
  ],
];

export default CheckCircle;
